jQuery(document).ready((function(t) {
    function e(t, e) {
        this.element = t,
        this.table = this.element.children(".cd-products-table"),
        this.productsWrapper = this.table.children(".cd-products-wrapper"),
        this.tableColumns = this.productsWrapper.children(".cd-products-columns"),
        this.products = this.tableColumns.find(".product"),
        this.productsNumber = this.products.length,
        this.productWidth = this.products.eq(0).width(),
        this.productsTopInfo = this.table.find(".top-info"),
        this.featuresTopInfo = this.table.children(".features").children(".top-info"),
        this.topInfoHeight = this.featuresTopInfo.innerHeight() + 30,
        this.fields = this.table.find(".features .cd-features-list"),
        this.leftScrolling = !1,
        this.filterBtn = this.element.find(".filter"),
        this.resetBtn = this.element.find(".reset"),
        this.filtering = !1,
        this.selectedproductsNumber = 0,
        this.filterActive = !1,
        this.navigation = this.table.children(".cd-table-navigation");
        var i = this.detectFields(e);
        this.fillFields(i),
        this.fillProductData(e, i),
        this.tableHeight = this.table.height(),
        this.bindEvents(),
        this.updateProperties()
    }
    e.prototype.detectFields = function(e) {
        var i = [];
        return this.products.each((function() {
            var s = t(this).data("product-handle");
            if (e[s])
                for (var r = 0; r < e[s].length; r++) {
                    var o = e[s][r];
                    -1 === i.indexOf(o.title) && i.push(o.title)
                }
        }
        )),
        i
    }
    ,
    e.prototype.fillFields = function(t) {
        for (var e = 0; e < t.length; e++)
            this.fields.append("<li>" + t[e] + "</li>")
    }
    ,
    e.prototype.fillProductData = function(e, i) {
        this.products.each((function() {
            var s = t(this)
              , r = s.find(".cd-features-list")
              , o = s.data("product-handle")
              , n = {};
            if (e[o]) {
                for (var a = 0; a < e[o].length; a++) {
                    var l = e[o][a];
                    -1 !== i.indexOf(l.title) && (n[l.title] = a)
                }
                for (a = 0; a < i.length; a++) {
                    var d = i[a]
                      , c = "N/A";
                    if (void 0 !== n[d])
                        c = (l = e[o][n[d]]).shortText || l.text;
                    r.append("<li>" + c + "</li>")
                }
            }
        }
        ))
    }
    ,
    e.prototype.bindEvents = function() {
        var e = this;
        e.productsWrapper.on("scroll", (function() {
            e.leftScrolling || (e.leftScrolling = !0,
            window.requestAnimationFrame ? window.requestAnimationFrame((function() {
                e.updateLeftScrolling()
            }
            )) : setTimeout((function() {
                e.updateLeftScrolling()
            }
            ), 250))
        }
        )),
        e.products.on("click", ".check", (function() {
            var i = t(this)
              , s = "true" === i.attr("aria-pressed");
            i.attr("aria-pressed", !s);
            var r = i.parents(".product");
            !e.filtering && r.hasClass("selected") ? (r.removeClass("selected"),
            e.selectedproductsNumber = e.selectedproductsNumber - 1,
            e.upadteFilterBtn()) : e.filtering && r.hasClass("selected") ? (r.removeClass("selected"),
            e.selectedproductsNumber = e.selectedproductsNumber - 1) : e.filtering || r.hasClass("selected") || (r.addClass("selected"),
            e.selectedproductsNumber = e.selectedproductsNumber + 1,
            e.upadteFilterBtn()),
            0 === e.selectedproductsNumber && e.resetBtn.trigger("click")
        }
        )),
        e.filterBtn.on("click", (function(i) {
            i.preventDefault(),
            e.filterActive && (e.filtering = !0,
            e.showSelection(),
            e.filterActive = !1,
            e.filterBtn.removeClass("active"),
            t("#filterActiveWarning").removeAttr("role"),
            t("#filterActiveWarning").hide(),
            e.filterBtn.attr("aria-disabled", !0),
            e.filterBtn.attr("aria-label", "Please select at least two Bikes to compare."))
        }
        )),
        e.resetBtn.on("click", (function(t) {
            t.preventDefault(),
            e.filtering ? (e.filtering = !1,
            e.resetSelection()) : e.products.removeClass("selected"),
            e.selectedproductsNumber = 0,
            e.upadteFilterBtn(),
            e.resetCheckboxes()
        }
        )),
        this.navigation.on("click", "a", (function(i) {
            i.preventDefault(),
            e.updateSlider(t(i.target).hasClass("next"))
        }
        ))
    }
    ,
    e.prototype.upadteFilterBtn = function() {
        this.selectedproductsNumber >= 2 ? (this.filterActive = !0,
        this.filterBtn.addClass("active"),
        t("#filterActiveWarning").attr("role", "alert"),
        t("#filterActiveWarning").show(),
        this.filterBtn.attr("aria-disabled", !1),
        this.filterBtn.attr("aria-label", "Click to filter.")) : (this.filterActive = !1,
        this.filterBtn.removeClass("active"),
        t("#filterActiveWarning").removeAttr("role"),
        t("#filterActiveWarning").hide(),
        this.filterBtn.attr("aria-disabled", !0),
        this.filterBtn.attr("aria-label", "Please select at least two Bikes to compare."))
    }
    ,
    e.prototype.updateLeftScrolling = function() {
        parseInt(this.tableColumns.eq(0).outerWidth(!0)),
        parseInt(this.element.width());
        var t = this.productsWrapper.scrollLeft();
        t > 0 ? this.table.addClass("scrolling") : this.table.removeClass("scrolling"),
        this.table.hasClass("top-fixed") && "desktop" == a() && (l(this.productsTopInfo, "-" + t),
        l(this.featuresTopInfo, "0")),
        this.leftScrolling = !1,
        this.updateNavigationVisibility(t)
    }
    ,
    e.prototype.updateNavigationVisibility = function(t) {
        t > 0 ? this.navigation.find(".prev").removeClass("inactive") : this.navigation.find(".prev").addClass("inactive"),
        t < this.tableColumns.outerWidth(!0) - this.productsWrapper.width() && this.tableColumns.outerWidth(!0) > this.productsWrapper.width() ? this.navigation.find(".next").removeClass("inactive") : this.navigation.find(".next").addClass("inactive")
    }
    ,
    e.prototype.updateTopScrolling = function(e) {
        var i = this.table.offset().top;
        this.productsWrapper.scrollLeft();
        i <= e && i + this.tableHeight - this.topInfoHeight >= e ? !this.table.hasClass("top-fixed") && t(document).height() > i + t(window).height() + 200 && (this.table.addClass("top-fixed").removeClass("top-scrolling"),
        "desktop" == a() && (this.productsTopInfo.css("top", "0"),
        this.navigation.find("a").css("top", "0px"))) : i <= e ? (this.table.removeClass("top-fixed").addClass("top-scrolling"),
        "desktop" == a() && (this.productsTopInfo.css("top", this.tableHeight - this.topInfoHeight + "px"),
        this.navigation.find("a").css("top", this.tableHeight - this.topInfoHeight + "px"))) : (this.table.removeClass("top-fixed top-scrolling"),
        this.productsTopInfo.attr("style", ""),
        this.navigation.find("a").attr("style", "")),
        this.updateLeftScrolling()
    }
    ,
    e.prototype.updateProperties = function() {
        this.tableHeight = this.table.height(),
        this.productWidth = this.products.eq(0).width(),
        this.topInfoHeight = this.featuresTopInfo.innerHeight() + 30,
        this.tableColumns.css("width", this.productWidth * this.productsNumber + "px")
    }
    ,
    e.prototype.showSelection = function() {
        this.element.addClass("filtering"),
        this.filterProducts()
    }
    ,
    e.prototype.resetSelection = function() {
        this.tableColumns.css("width", this.productWidth * this.productsNumber + "px"),
        this.element.removeClass("no-product-transition"),
        this.resetProductsVisibility()
    }
    ,
    e.prototype.filterProducts = function() {
        var e = this
          , i = e.tableColumns.offset().left
          , s = e.productsWrapper.scrollLeft()
          , r = this.products.filter(".selected")
          , o = r.length;
        r.each((function(n) {
            var a = t(this)
              , d = i + n * e.productWidth + s - a.offset().left;
            l(a, d),
            n == o - 1 && a.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", (function() {
                setTimeout((function() {
                    e.element.addClass("no-product-transition")
                }
                ), 50),
                setTimeout((function() {
                    e.element.addClass("filtered"),
                    e.productsWrapper.scrollLeft(0),
                    e.tableColumns.css("width", e.productWidth * o + "px"),
                    r.attr("style", ""),
                    a.off("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"),
                    e.updateNavigationVisibility(0)
                }
                ), 100)
            }
            ))
        }
        )),
        t(".no-csstransitions").length > 0 && (e.element.addClass("filtered"),
        e.productsWrapper.scrollLeft(0),
        e.tableColumns.css("width", e.productWidth * o + "px"),
        r.attr("style", ""),
        e.updateNavigationVisibility(0))
    }
    ,
    e.prototype.resetCheckboxes = function() {
        this.element.find(".check").each((function() {
            t(this).attr("aria-pressed", !1)
        }
        ))
    }
    ,
    e.prototype.resetProductsVisibility = function() {
        var e = this
          , i = (e.tableColumns.offset().left,
        this.products.filter(".selected"))
          , s = (i.length,
        e.productsWrapper.scrollLeft(),
        0);
        e.element.addClass("no-product-transition").removeClass("filtered"),
        e.products.each((function(i) {
            var r = t(this);
            r.hasClass("selected") && l(r, (-i + (s += 1) - 1) * e.productWidth)
        }
        )),
        setTimeout((function() {
            e.element.removeClass("no-product-transition filtering"),
            l(i, "0"),
            i.removeClass("selected").attr("style", "")
        }
        ), 50)
    }
    ,
    e.prototype.updateSlider = function(t) {
        var e = this.productsWrapper.scrollLeft();
        (e = t ? e + this.productWidth : e - this.productWidth) < 0 && (e = 0),
        e > this.tableColumns.outerWidth(!0) - this.productsWrapper.width() && (e = this.tableColumns.outerWidth(!0) - this.productsWrapper.width()),
        this.productsWrapper.animate({
            scrollLeft: e
        }, 200)
    }
    ;
    var i = [];
    t(".cd-products-comparison-table").each((function() {
        i.push(new e(t(this),window.compareData))
    }
    ));
    var s = !1;
    t(window).on("scroll", (function() {
        s || (s = !0,
        window.requestAnimationFrame ? window.requestAnimationFrame(o) : setTimeout(o, 250))
    }
    ));
    var r = !1;
    function o() {
        var e = t(window).scrollTop();
        i.forEach((function(t) {
            t.updateTopScrolling(e)
        }
        )),
        s = !1
    }
    function n() {
        i.forEach((function(t) {
            t.updateProperties()
        }
        )),
        r = !1
    }
    function a() {
        return window.getComputedStyle(i[0].element.get(0), "::after").getPropertyValue("content").replace(/'/g, "").replace(/"/g, "")
    }
    function l(t, e) {
        t.css({
            "-moz-transform": "translateX(" + e + "px)",
            "-webkit-transform": "translateX(" + e + "px)",
            "-ms-transform": "translateX(" + e + "px)",
            "-o-transform": "translateX(" + e + "px)",
            transform: "translateX(" + e + "px)"
        })
    }
    t(window).on("resize", (function() {
        r || (r = !0,
        window.requestAnimationFrame ? window.requestAnimationFrame(n) : setTimeout(n, 250))
    }
    ))
}
));
